// Infra-Fonds-Datenbank: these admins are always "full" (mirrors backend routers/team.py INFRA_FUNDS_ALLOWED);
// everyone else gets the level an admin sets in Team → Infra-Fonds (user.infra_access from /auth/me).
export const INFRA_FUNDS_ALLOWED = ['talu@olta-nachfolge.com', 'emergent.test@olta-nachfolge.com'];
export const INFRA_LEVEL_LABELS = { none: 'kein Zugriff', screen: 'nur Deals suchen', full: 'voll' };

export const infraLevel = (user) => {
  if (!user) return 'none';
  if (user.role === 'admin' && INFRA_FUNDS_ALLOWED.includes((user.email || '').toLowerCase())) return 'full';
  return ['screen', 'full'].includes(user.infra_access) ? user.infra_access : 'none';
};
// read the database + start screenings (existing funds / themes / angles / portfolio deals — Claude scoring only)
export const canSeeInfraFunds = (user) => infraLevel(user) !== 'none';
// cost-generating / changing actions: create funds, Perplexity research, deal import + research, delete, pin
export const canManageInfraFunds = (user) => infraLevel(user) === 'full';
